import { useMutation, } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
export const createBreweriesQueries = (requests, queryClient) => ({
    useListBreweries: (params, options = {}) => useQuery({
        queryKey: ["breweries", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listBreweries(params);
        },
        ...options,
    }),
    useFindBrewery: (params, options = {}) => useQuery({
        queryKey: ["breweries", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findBrewery(params);
        },
        ...options,
    }),
    useCreateBrewery: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createBrewery,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["breweries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateBrewery: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.updateBrewery,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["breweries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map